// Reload the page ONLY when the app is actually reachable.
//
// These signage screens run on weak/intermittent internet. A blind
// `window.location.reload()` while the connection is down leaves the screen
// blank, because the browser can't re-download the app — and it never recovers
// on its own. So before reloading we probe connectivity; if it fails we wait
// and retry instead of reloading into a blank page.
export default function safeReload({ retryMs = 30000, probeUrl } = {}) {
    const url = probeUrl || window.location.href;

    const attempt = () => {
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            console.log('safeReload: offline, will retry');
            setTimeout(attempt, retryMs);
            return;
        }
        fetch(url, { method: 'GET', cache: 'no-store' })
            .then((res) => {
                if (res && res.ok) {
                    window.location.reload();
                } else {
                    console.log('safeReload: server not reachable, will retry');
                    setTimeout(attempt, retryMs);
                }
            })
            .catch((err) => {
                console.log('safeReload: connectivity check failed, will retry', err);
                setTimeout(attempt, retryMs);
            });
    };

    attempt();
}
